export interface RegistryConfig {
  /** Run the whole console on the in-browser mock store with no sign-in or backend. */
  mockOnly: boolean;
  auth0Domain?: string;
  auth0ClientId?: string;
  audience?: string;
}

function read(get: () => string | undefined): string | undefined {
  try {
    return get() || undefined;
  } catch {
    return undefined;
  }
}

/**
 * Each `process.env.REACT_APP_*` stays a literal expression so the Vite/webpack define plugins
 * can substitute it at build time. The registry's own Auth0 application falls back to the
 * admin portal's until it is created.
 */
export function getRegistryConfig(): RegistryConfig {
  return {
    mockOnly: read(() => process.env.REACT_APP_REGISTRY_MOCK) === 'true',
    auth0Domain: read(() => process.env.REACT_APP_AUTH0_DOMAIN),
    auth0ClientId:
      read(() => process.env.REACT_APP_REGISTRY_AUTH0_CLIENT_ID) ??
      read(() => process.env.REACT_APP_AUTH0_CLIENT_ID),
    audience: read(() => process.env.REACT_APP_BACKEND_AUDIENCE),
  };
}
